// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR = "Bazar";
export const BLOGS = "P\u0159\u00edsp\u011bvky";
export const HOMEPAGE_FEED_NAV_TAB_FORUM = "Diskuze";
export const MAIN_MENU_REVIEWS = "Recenze";
export const TAB_GROUPS = "Skupiny";
